import type { CurrencyDefinition } from "./CurrencyCatalogTypes";

export interface CurrencyRegistry {
  get(currencyCode: string): CurrencyDefinition | null;
}

export class InMemoryCurrencyRegistry implements CurrencyRegistry {
  private readonly byCode: Record<string, CurrencyDefinition>;

  public constructor(byCode: Record<string, CurrencyDefinition>) {
    this.byCode = byCode;
  }

  public get(currencyCode: string): CurrencyDefinition | null {
    return this.byCode[currencyCode] ?? null;
  }
}